var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3538 5.52053L6.35375 13.5205C6.30732 13.567 6.25217 13.6039 6.19147 13.6291C6.13077 13.6542 6.06571 13.6672 6 13.6672C5.9343 13.6672 5.86923 13.6542 5.80853 13.6291C5.74783 13.6039 5.69269 13.567 5.64625 13.5205L2.14625 10.0205C2.05243 9.92671 1.99973 9.79946 1.99973 9.66678C1.99973 9.5341 2.05243 9.40685 2.14625 9.31303C2.24007 9.21921 2.36732 9.1665 2.5 9.1665C2.63269 9.1665 2.75993 9.21921 2.85375 9.31303L6 12.4599L13.6463 4.81303C13.7401 4.71921 13.8673 4.6665 14 4.6665C14.1327 4.6665 14.2599 4.71921 14.3538 4.81303C14.4476 4.90685 14.5003 5.0341 14.5003 5.16678C14.5003 5.29946 14.4476 5.42671 14.3538 5.52053Z",
    fill: "#121926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.913b21ef5d78428915452406cf7ad2e1.svg";
export { ForwardRef as ReactComponent };